export default "__VITE_ASSET__CHQ0h8_9__"